import React from 'react'
import { Section, SectionTitle } from '../Section/section'
import { Tabs, Tab } from '../Tabs'
import LectureDiscussion from './LectureDiscussion'
import { Container } from '../Container/containers'

const LectureComment = () => {
  return (
    <Container>
      <Section>
        <SectionTitle position="left">
          <h4>講座前討論與評價</h4>
        </SectionTitle>
        <Tabs id="TabsExample" selectedTabId="discussion">
          <Tab
            id="discussion"
            title="講座前討論"
            panel={<LectureDiscussion />}
          />
          <Tab id="comment" title="講座評價" disabled={true} />
        </Tabs>
      </Section>
    </Container>
  )
}

export default LectureComment



// WEBPACK FOOTER //
// ./src/components/LectureComment/LectureComment.js